module.exports = __webpack_public_path__ + "static/media/00waterfall.d434e08e.webp";